import BaseService from '@/services/base.service'
import baseApi from './base.api'
import { dataURLtoFile, toast } from '@/common/util'
import authStore from '@/stores/authStore'
import { useParams } from '@/composables/useParams'

interface IOpenParams {
  subDomain: string
  clientUrl?: string
}

export const paramsService = {
  ...baseApi,
  resource: 'parametro',
  async uploadFile(data: File | string, fileName?: string) {
    const formData = new FormData()
    formData.append('arquivo', typeof data === 'string' ? dataURLtoFile(data, fileName) : data)

    return paramsService.post<string>(`AdicionarArquivo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  batchReplication: (contractIds: string[]) => {
    const { batchMode } = useParams()

    // Verifica a necessidade de upload de banners
    if (batchMode.settings.banners) {
      batchMode.parameters.banners.items.forEach((item) => {
        if (item.url.startsWith('data:image')) {
          item.url = ''
        }
      })
    }

    if (batchMode.settings.theme && batchMode.parameters.theme.defaultTheme !== 'DefinidoPeloUsuario') batchMode.parameters.theme.initialTheme = null


    if (batchMode.settings.theme) {
      //@ts-ignore
      batchMode.parameters.tema = {
        temaPadrao: batchMode.parameters.theme.defaultTheme,
        temaDeInicializacao: batchMode.parameters.theme.initialTheme
      }
    }

    return paramsService.put('BatchReplication', {
      contractIds,
      parameters: batchMode.parameters,
      replicationSpecificParameter: batchMode.settings
    })
  }
}

class ParametrosService extends BaseService {
  constructor() {
    super({ resource: 'parametro' })
  }

  // @ts-ignore
  async update(data: {}) {
    return this.plantarApi.put(this.resource, {
      ...data,
      tenantId: authStore().getActiveTentant
    })
  }

  async dataUrlUpload(data: File | string, fileName?: string) {
    const formData = new FormData()
    formData.append('arquivo', typeof data === 'string' ? dataURLtoFile(data, fileName) : data)

    return await this.plantarApi.post(`${this.resource}/AdicionarArquivo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }

  async deleteImg(url: string) {
    return await this.plantarApi.delete(`${this.resource}/RemoverArquivo/${url}`)
  }

  async clientSettings(opt: IOpenParams) {
    const { subDomain, clientUrl } = opt
    const postData: IOpenParams = { subDomain }
    if (clientUrl) postData.clientUrl = clientUrl

    // Criar AbortController para cancelar a requisição após 40 segundos
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 40000)

    try {
      const { success, data } = await this.plantarApi.post(`open/parametros`, postData, {
        headers: { 'X-Tenant': (window as any)?.configuration?.plantar?.tenant },
        signal: controller.signal
      })

      clearTimeout(timeoutId)
      return {
        success,
        data
      }
    } catch (error: any) {
      clearTimeout(timeoutId)
      if (error.name === 'AbortError') {
        toast.error({
          title: 'Erro',
          message: 'O tempo de requisição foi excedido, o servidor não respondeu a tempo.'
        })
        throw new Error('Timeout de 40 segundos atingido')
      }
      throw error
    }
  }
}

const parametrosService = new ParametrosService()

export default parametrosService
